function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".devicea{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-774.008 -7979.805)"
}, /*#__PURE__*/React.createElement("path", {
  className: "devicea",
  d: "M795.222,7986.2H774.794a.786.786,0,0,1-.786-.786v-4.826a.786.786,0,0,1,.786-.786h20.429a.786.786,0,0,1,.786.786v4.826A.786.786,0,0,1,795.222,7986.2Zm-19.643-1.571h18.857v-3.255H775.579Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "devicea",
  d: "M797.7,8013.843H780a.786.786,0,0,1-.786-.786v-14.039a.786.786,0,0,1,.786-.786h17.7a.786.786,0,0,1,.786.786v14.039A.786.786,0,0,1,797.7,8013.843Zm-16.915-1.571h16.129V7999.8H780.788Z",
  transform: "translate(-3.845 -13.601)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3266.706 5040.18) rotate(-45)"
}, /*#__PURE__*/React.createElement("path", {
  className: "devicea",
  d: "M782.239,4955.827a.812.812,0,0,1-.812-.812,6.252,6.252,0,0,0-6.247-6.243.812.812,0,0,1,0-1.624,7.878,7.878,0,0,1,7.871,7.867A.811.811,0,0,1,782.239,4955.827Z",
  transform: "translate(-0.07 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "devicea",
  d: "M779.185,4964.056h0a.813.813,0,0,1-.812-.812,3.189,3.189,0,0,0-3.19-3.188h0a.812.812,0,0,1,0-1.624h0a4.812,4.812,0,0,1,4.814,4.813A.812.812,0,0,1,779.185,4964.056Z",
  transform: "translate(-0.072 -8.23)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "devicea",
  cx: 1.233,
  cy: 1.233,
  r: 1.233,
  transform: "translate(774.272 4953.353)"
})));

var SvgDevice = function SvgDevice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20.436,
    viewBox: "0 0 22 20.436",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/device.32301ab9.svg";
export { ForwardRef as ReactComponent };